import { createAsyncThunk } from '@reduxjs/toolkit'
import { RootState } from '../../infrastructure/redux/store'
import { getHoroscopeBySign } from '../../infrastructure/repositories/casaArcanaRepository.ts'

export const fetchHoroscope = createAsyncThunk(
  'horoscope/fetch',
  async (sign: string, { getState }) => {
    const state = getState() as RootState
    const baseURL = state.api.baseURL
    return await getHoroscopeBySign(baseURL, sign)
  }
)